



















































import Vue from 'vue';
import { mapState } from 'vuex';

import Section from '@/components/Bulma/Section.vue';
import CardGallery from '@/components/CardGallery.vue';
import ProductCard from '@/components/ProductCard.vue';
import CharacterCard from '@/components/CharacterCard.vue';
import ItemCard from '@/components/ItemCard.vue';

import Product from '@/types/Product';
import Character from '@/types/Character';
import Item from '@/types/Item';

import Util from '@/util/Util';

export default Vue.extend({
  name: 'Home',

	components: {
		Section,
		CardGallery,
		ProductCard,
		CharacterCard,
		ItemCard
	},

	created() {
		Util.updateHeaders((this as any).$text('home'), (this as any).$text('homeDescription'), process.env.VUE_APP_DEFAULT_IMAGE);
	},

    data() {
        return {
            links: [
				{
					imageUrl: 'https://image.moominhouse.se/static/collection_2270x2270.jpg',
					text: 'home.links.collection',
					route: 'collection'
				},
				{
					imageUrl: 'https://image.moominhouse.se/static/read_about_products_2500x2500.jpg',
					text: 'home.links.products',
					route: 'products'
				},
				{
					imageUrl: 'https://image.moominhouse.se/static/buy_favorite_2286x2286.jpg',
					text: 'home.links.buy',
					route: 'shop'
				},
				{
					imageUrl: 'https://image.moominhouse.se/static/characters_1240x1240.jpg',
					text: 'home.links.characters',
					route: 'characters'
				}
			]
        };
    },

	computed: {
		...mapState(['language', 'mostPopularCharacterTuples', 'mostPopularItems']),

        products(): Product[] {
            return this.$store.getters.getMostLikedProducts(10);
        }
    },

    methods: {
		selectProduct(product: Product): void {
			this.$router.push({ name: 'product', params: { productId: product.productId } });
		},

		selectCharacter(character: Character): void {
			this.$router.push({ name: 'character', params: { characterId: character.characterId } });
		},

		selectItem(item: Item): void {
			this.$router.push({ name: 'item', params: { itemId: item.itemId } });
		},

		routeTo(route: string): void {
            this.$router.push({ name: route });
        },
	}
});
